const BACKEND_BASE_LOCATION = process.env.REACT_APP_BASE_URL;

if (!BACKEND_BASE_LOCATION) {
  throw new Error("BACKEND_BASE_LOCATION not set!");
}

const API_BASE_URL = `${process.env.REACT_APP_BASE_URL}api/`;
if (!API_BASE_URL) {
  throw new Error("API host not set!");
}

const BACKEND_BASE_IMAGE_LOCATION =
  BACKEND_BASE_LOCATION.length > 0
    ? BACKEND_BASE_LOCATION.slice(0, -1)
    : BACKEND_BASE_LOCATION;

const PHONE_NUMBER_SUPPORT_ENV =
  process.env.REACT_APP_PHONE_NUMBER_SUPPORT_ENABLED;

if (!PHONE_NUMBER_SUPPORT_ENV) {
  throw new Error("Phone number support key not set!");
}
// Now we know the value exists, get the boolean representation
const IS_PHONE_NUMBER_SUPPORT_ENABLED = PHONE_NUMBER_SUPPORT_ENV === "true";

const BANNER_MESSAGE = process.env.REACT_APP_BANNER_MESSAGE;

const QUERY_ENCODE_DECODE_SECRET_KEY =
  process.env.REACT_APP_QUERY_ENCODING_DECODING_SECRET_KEY;
if (!QUERY_ENCODE_DECODE_SECRET_KEY) {
  throw new Error("No Secret Key defined");
}

const DONATION_ITEM_ID = 1;

const BUYOUT_ITEM_ID = 2;
const REACT_APP_SITE_URL = process.env.REACT_APP_SITE_URL;
if (!REACT_APP_SITE_URL) {
  throw new Error("No Base frontend site defined");
}

const SITE_NAME = "Fundraise With Mamfam";
const SUPPORT_EMAIL = "help@themakeamemoryfamily.com";

const config = {
  API_BASE_URL,
  BACKEND_BASE_LOCATION,
  BANNER_MESSAGE,
  BACKEND_BASE_IMAGE_LOCATION,
  IS_PHONE_NUMBER_SUPPORT_ENABLED,
  QUERY_ENCODE_DECODE_SECRET_KEY,
  DONATION_ITEM_ID,
  BUYOUT_ITEM_ID,
  REACT_APP_SITE_URL,
  SITE_NAME,
  SUPPORT_EMAIL,
};

export default config;
